import ManagerList from './views/ManagerList.vue';
import ManagerEdit from './views/ManagerEdit.vue';
import Manager from './Root.vue';

export default {
  path: 'gerentes/',
  component: Manager,
  name: 'admin-manager',
  redirect: '/gerentes/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-manager-list',
      component: ManagerList,
    },
    {
      path: ':id',
      name: 'admin-manager-edit',
      component: ManagerEdit,
    },
  ],
};
